import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form, DatePicker, Select, message } from "antd";
import moment from "moment";
import ChronicConditionService from "../../../../../Services/ChronicConditionService";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

function AddChronicCondition({
  handlSetLocalMappedChronics,
  handleModalClose,
}) {
  const [chronicValue, setChronicValue] = useState();
  const [chronicCode, setChronicCode] = useState([]);
  const [chronicDesc, setChronicDesc] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const formRef = useRef();
  const { selectedEditPatient } = useSelector((state) => state.patients);
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const handleFromDate = (date) => {
    setFromDate(date);
  };

  const handleToDate = (date) => {
    setToDate(date);
  };

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const disabledPastDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handlehealthChange = (value, desc) => {
    setChronicValue(value);
    setChronicDesc(desc.description);
  };

  const ChronicCode = () => {
    let payload = {
      status: 1,
    };
    ChronicConditionService.chronicConditions(payload).then((result) => {
      setChronicCode(result.data);
    });
  };

  useEffect(() => {
    ChronicCode();
  }, []);

  const onFinish = (e) => {
    e.preventDefault();

    const { pastInfo, fromDate, toDate, givenDate } =
      formRef.current.getFieldValue();
    if (!pastInfo || !givenDate) {
      message.error("Please fill all fields");
      setIsLoading(false);
      return;
    }
    let payload = {
      account_Id: loggedUser?.user?.account_Id,
      clinic_Id: loggedUser?.user?.clinic_Id,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      givenDate: convertUTCDate(givenDate, "YYYY-MM-DD HH:mm:ss"),
      createdBy: loggedUser?.user?.userId,
      modifiedBy: loggedUser?.user?.userId,
      status: 1,
      chronicCode: chronicValue,
      chronicDescription: chronicDesc,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      createdName: loggedUser?.user?.userName,
      fromDate: convertUTCDate(fromDate, "YYYY-MM-DD HH:mm:ss"),
      toDate: convertUTCDate(toDate, "YYYY-MM-DD HH:mm:ss"),
      userId: loggedUser?.user?.userId,
    };

    if (selectedEditPatient) {
      payload.patientId = selectedEditPatient.patientId;
      payload.patientName =
        selectedEditPatient?.salutation +
        " " +
        selectedEditPatient?.firstName +
        " " +
        selectedEditPatient?.lastName;
    }

    handlSetLocalMappedChronics(payload);
    handleModalClose();
  };

  const disablePastFromDateInToDate = (current) => {
    return fromDate && current && current < dayjs(fromDate).startOf("day");
  };

  return (
    <div>
      <Form
        ref={formRef}
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
      >
        <Row gutter={20}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  Chronic Condition <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="pastInfo"
            >
              <Select
                style={{ width: "100%" }}
                onChange={handlehealthChange}
                placeholder="Select"
                showSearch
                allowClear
                value={chronicValue}
                options={chronicCode.map((ele) => ({
                  value: ele.code,
                  description: ele.description,
                  label: ele.description,
                  key: ele.value,
                }))}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  Given Date<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="givenDate"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  From Date<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="fromDate"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleFromDate}
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span>
                  To Date<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="toDate"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleToDate}
                disabledDate={disablePastFromDateInToDate}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Col className="gutter-row" span={24}>
        <div className="flex items-center w-full justify-end my-5">
          <button
            onClick={handleModalClose}
            className="border-brand-primaryColor bg-white border rounded text-brand-primaryColor text-sm px-6 py-1.5"
          >
            Cancel
          </button>
          <button
            disabled={isLoading}
            onClick={onFinish}
            className="custom_filter rounded px-5 py-1.5 text-white text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Submit
          </button>
        </div>
      </Col>
    </div>
  );
}

export default AddChronicCondition;
